﻿import {Context, createContext} from "react";
import {WizardValues} from "./WizardValues";

export const WizardContext: Context<WizardValues | null> = createContext<WizardValues | null>(null);
